import React, { useCallback, useMemo, useState } from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import _ from 'lodash'

import api from 'Src/api'

import { fetchFlows } from 'Src/actions/bots'
import Button from 'Design/components/Button'

const CREATE_FLOW_URL = 'v1/bot-profiles/:botId/bot-flows'

const CreateFlowModal = ({ isOpen, hide, botId, container, onAddBotFlow }) => {
  const [apiError, setApiError] = useState(null)
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm()
  const dispatch = useDispatch()

  const onClose = useCallback(hide, [hide])

  const onFormSubmit = async (data) => {
    try {
      const payload = {
        id: botId,
        name: data.name
      }

      if (container === 'newDesign') {
        onAddBotFlow(payload)
      } else {
        await api.post(CREATE_FLOW_URL, payload, { urlParams: { botId } })
        dispatch(fetchFlows(botId))
      }
      hide()
    } catch (err) {
      console.error('Error while creating a flow', err)

      const responseMessage = _.get(err, 'response.data.message')
      const errors = _.get(err, 'response.data.errors')

      if (errors && _.isArray(errors)) {
        const errorMessages = _.map(errors, 'message').join('\n')
        setApiError(errorMessages)
      } else {
        setApiError(responseMessage)
      }
    }
  }

  const nameRegister = useMemo(
    () =>
      register('name', {
        required: 'Name is required',
        minLength: {
          value: 3,
          message: 'Name should contain at least 3 characters'
        },
        pattern: {
          value: /^[a-zA-Z0-9\s-]+$/,
          message: 'Flow name should contain only alpha numeric characters'
        },
        validate: {
          onlySpaces: (v) => (v.trim().length === 0 ? 'Name is required' : true),
          minLenthTrimmed: (v) => (v.trim().length >= 3 ? true : 'Name should contain at least 3 characters')
        }
      }),
    [register]
  )

  return (
    <div>
      <Modal
        isOpen={isOpen}
        contentLabel='Create Bot Modal'
        ariaHideApp={false}
        onRequestClose={onClose}
        className={container === 'newDesign' ? 'new-design' : ''}
      >
        <div className='modal-header'>
          {container === 'newDesign' ? <h2>New Bot</h2> : <h2>Add Flow</h2>}
          <div className='modal-close' onClick={onClose}>
            &times;
          </div>
        </div>
        <div className='modal-body'>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <div className='form-group'>
              {container === 'newDesign' ? <label>Give this bot a name</label> : <label>Give this flow a name</label>}
              <input
                className={classNames('form-control', { 'is-invalid': errors.name })}
                {...nameRegister}
                onChange={(e) => {
                  nameRegister.onChange(e)
                  if (apiError) {
                    setApiError(null)
                  }
                }}
              />
              {errors.name && <small className='form-text text-danger'>{errors.name.message}</small>}
            </div>
            <Button className='button-primary' type='submit'>
              Save
            </Button>
          </form>
          {apiError && (
            <div className='alert alert-danger mt-2' role='alert'>
              <span>{apiError}</span>
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default CreateFlowModal
